import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Form.css'; // using Form.css for the look & feel

const HearingRequestForm = () => {
  const query = new URLSearchParams(useLocation().search);
  // The "userId" here is actually the hifi_setups id.
  const setupId = query.get('userId');

  const [senderEmail, setSenderEmail] = useState('');
  const [message, setMessage] = useState('');
  const [captcha, setCaptcha] = useState('');
  const [captchaQuestion, setCaptchaQuestion] = useState('');
  const [captchaExpected, setCaptchaExpected] = useState('');
  const [statusMessage, setStatusMessage] = useState('');

  // Generate a simple random addition captcha question when component mounts
  useEffect(() => {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    setCaptchaQuestion(`Was ist ${a} + ${b}?`);
    setCaptchaExpected((a + b).toString());
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!senderEmail) {
      setStatusMessage('Bitte gib eine gültige Email-Adresse ein. Ohne korrekte Email, keine Anfrage möglich!');
      return;
    }
    if (message.length > 300) {
      setStatusMessage('Die Nachricht darf maximal 300 Zeichen lang sein.');
      return;
    }
    if (captcha.trim() !== captchaExpected) {
      setStatusMessage('Captcha fehlgeschlagen. Bitte versuche es erneut.');
      return;
    }

    const subject = 'HiFiCouch.World Hörsession Anfrage für Dein Setup!';

    try {
      const response = await fetch('/api/request-hearsession', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        // Pass the setupId in the userId field – the backend will resolve the correct user.
        body: JSON.stringify({
          userId: setupId,
          senderEmail,
          subject,
          message
        })
      });
      const result = await response.json();

      if (response.ok) {
        setStatusMessage('Anfrage erfolgreich abgeschickt!');
      } else {
        setStatusMessage(result.error || 'Fehler beim Absenden der Anfrage.');
      }
    } catch (error) {
      setStatusMessage('Fehler beim Absenden der Anfrage.');
    }
  };

  return (
    <div className="form-container">
      <h2>Hörsession Anfrage</h2>
      <div className="info-box">
        <strong>
          Die registrierte E-Mail dieses Benutzer wird nicht angezeigt und im Hintergrund sicher ausgelesen und danach eine Info mit Deiner eingetragenen E-Mail an den Benutzer dieses Setups. Es ist dem Benutzer überlassen, ob er mit Dir in Kontakt tritt!
        </strong><p> &nbsp;</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Betreff</label>
          <input
            type="text"
            value="HiFiCouch.World - Hörsession Anfrage für DEIN Setup!"
            readOnly
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Deine Email <span style={{ color: 'red' }}>*</span></label>
          <input
            type="email"
            value={senderEmail}
            onChange={(e) => setSenderEmail(e.target.value)}
            placeholder="Ohne korrekte Email, keine Anfrage möglich!"
            required
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label>Kurze Nachricht (max. 300 Zeichen)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            maxLength="200"
            className="form-control"
            rows="4"
          />
        </div>
        <div className="form-group">
          <label>{captchaQuestion}</label>
          <input
            type="text"
            value={captcha}
            onChange={(e) => setCaptcha(e.target.value)}
            required
            className="form-control"
          />
        </div>
        <button type="submit">
          Absenden
        </button>
      </form>
      {statusMessage && <div className="error-message">{statusMessage}</div>}
    </div>
  );
};

export default HearingRequestForm;